<template>
  <div class="fit-content">
    <div>
      <DataTableDeCrud
        :items="fornecedores"
        :headers="headers"
        :rotina-id="ID_TELA_DE_FORNECEDOR"
        :configurar="false"
        :loading="loading"
        sort-by="nome"
        :busca-param="buscaParam"
        @create="() => abrirDialogCriarFornecedor()"
        @update="(indice) => abrirDialogEditarFornecedor(indice)"
        @delete="(indice) => openDialogDeleteFornecedor(indice)"
      >
        <template #[`item.conferido`]="{ item }">
          <v-icon v-if="item.conferido" color="green">mdi-check</v-icon>
          <v-icon v-else color="red">mdi-close</v-icon>
        </template>
      </DataTableDeCrud>

      <DialogDeEdicaoDeFornecedor
        :operacao="operacao"
        :show-dialog.sync="showDialogParam"
        :fornecedor-param="fornecedorParam"
        :itens="itensParam"
        @confirmado="atualizarFornecedor"
      />

      <SnackbarMessage
        :show-snack.sync="snackbar.showSnackParam"
        :snack-text="snackbar.snackTextParam"
        :snack-type="snackbar.snackTypeParam"
      />

      <v-dialog v-model="dialogDeleteFornecedor" persistent max-width="380">
        <v-card>
          <v-card-title class="headline">Excluir</v-card-title>
          <v-card-text refs="fornecedorDelete">
            Tem certeza que deseja excluir o fornecedor <b> {{ fornecedorDelete.nome }} </b>?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialogDeleteFornecedor = false"
              >Cancelar</v-btn
            >
            <v-btn color="green darken-1" text @click="removerFornecedor">Confirmar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import FornecedorService from '../../../services/fornecedor/fornecedor'
import UFService from '../../../services/uf/uf'
import SnackbarMessage from '../../../components/SnackbarMessage'
import DialogDeEdicaoDeFornecedor from '../../../components/fornecedores/DialogDeEdicaoDeFornecedor'
import DataTableDeCrud from '../../../components/DataTableDeCrud'
import SnackBar from '../../../models/components/snackbar'
import Fornecedor from '../../../models/fornecedor'
import { formataCpfCnpj } from '../../../shareds/formatacoes'
import { ID_TELA_DE_FORNECEDOR } from '@/common/constants'

export default {
  components: {
    SnackbarMessage,
    DataTableDeCrud,
    DialogDeEdicaoDeFornecedor
  },
  data: () => ({
    name: 'TelaDeFornecedor',
    headers: [
      { text: 'Nome', value: 'nome' },
      { text: 'Documento', value: 'documento' },
      { text: 'UF', value: 'uf.sigla' },
      { text: 'Tipo Fornecedor', value: 'tipoFornecedor' },
      { text: 'Conferido', value: 'conferido' }
    ],
    itensTiposFornecedores: [
      { text: 'Comércio', value: 'COMERCIO' },
      { text: 'Comércio Carne Fora de SC Art. 12-B', value: 'COMERCIO_CARNE_FORA_DE_SC_ART_12B' },
      { text: 'Distribuidora', value: 'DISTRIBUIDORA' },
      {
        text: 'Distribuidora Carne Fora de SC Art. 12-B',
        value: 'DISTRIBUIDORA_CARNE_FOR_DE_SC_ART_12B'
      },
      { text: 'Fábrica', value: 'FABRICA' },
      { text: 'Fábrica 10.49', value: 'FABRICA_10_49' },
      { text: 'Fábrica do Simples', value: 'FABRICA_DO_SIMPLES' },
      { text: 'Produtor Rural', value: 'PRODUTOR_RURAL' },
      { text: 'Simples', value: 'SIMPLES' }
    ],
    fornecedores: [],
    loading: false,
    dialog: false,
    operacao: '',
    showDialogParam: false,
    fornecedorParam: new Fornecedor(),
    itensParam: {},
    snackbar: new SnackBar(),
    dialogDeleteFornecedor: false,
    fornecedorDelete: new Fornecedor(),
    indiceFornecedorDelete: 0,
    ID_TELA_DE_FORNECEDOR: ID_TELA_DE_FORNECEDOR
  }),

  computed: {
    buscaParam() {
      return this.$route.query.documento
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      try {
        this.loadFornecedores()
        this.loadUFs()
      } catch (error) {
        this.snackbar.snackTextParam = 'Ocorreu um erro ao se comunicar com o servidor.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
    },

    async loadFornecedores() {
      this.loading = true
      const response = await FornecedorService.getAll()
      this.fornecedores = response.map((item) => ({
        ...item,
        documento: formataCpfCnpj(item.documento)
      }))
      this.loading = false
    },

    async loadUFs() {
      const response = await UFService.getAll()
      this.itensUF = response.map((item) => ({ text: item.sigla, value: item.id }))
    },

    atualizarFornecedor(fornecedor) {
      if (!fornecedor) return

      fornecedor.documento = formataCpfCnpj(fornecedor.documento)

      const indice = this.fornecedores.findIndex(
        (fornecedorExistente) => fornecedorExistente.id === fornecedor.id
      )

      if (indice === -1) {
        this.fornecedores.push(fornecedor)
        this.snackbar.snackTextParam = 'Fornecedor criado com sucesso.'
      } else {
        this.fornecedores.splice(indice, 1, fornecedor)
        this.snackbar.snackTextParam = 'Fornecedor atualizado com sucesso.'
      }

      this.snackbar.snackTypeParam = 'sucess'
      this.snackbar.showSnackParam = true
    },

    openDialogDeleteFornecedor(indice) {
      this.fornecedorDelete = this.fornecedores[indice]
      if (!this.fornecedorDelete.id) return

      this.indiceFornecedorDelete = indice
      this.dialogDeleteFornecedor = true
    },

    async removerFornecedor() {
      try {
        await FornecedorService.deleteById(this.fornecedorDelete.id)
        this.snackbar.snackTextParam = 'Fornecedor removido com sucesso.'
        this.snackbar.snackTypeParam = 'sucess'
        this.snackbar.showSnackParam = true
        this.fornecedores.splice(this.indiceFornecedorDelete, 1)
      } catch (error) {
        this.snackbar.snackTextParam = 'Não foi possível excluir o fornecedor.'
        this.snackbar.snackTypeParam = 'error'
        this.snackbar.showSnackParam = true
      }
      this.dialogDeleteFornecedor = false
    },

    abrirDialogCriarFornecedor() {
      this.operacao = 'adicionar'
      this.itensParam = { uf: this.itensUF, tiposFornecedores: this.itensTiposFornecedores }
      this.fornecedorParam = new Fornecedor()
      this.showDialogParam = true
    },

    abrirDialogEditarFornecedor(indice) {
      this.operacao = 'editar'
      this.itensParam = { uf: this.itensUF, tiposFornecedores: this.itensTiposFornecedores }
      this.fornecedorParam = { ...this.fornecedores[indice] }
      this.showDialogParam = true
    }
  }
}
</script>
